import EndPointConfig from '../../models/api/EndPointConfig'

const controller = 'StaticData'

export const StaticDataEP : EndPointConfig[] =[

         new EndPointConfig()
        .setMethod("PATCH")
        .setController(controller)
        .setActionName("ForceRefreshCache"),
]